<template>
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20 10.9785C20 16.4998 15.5254 20.976 10.0046 20.9785H9.89667C9.41192 20.9735 8.92817 20.9335 8.44917 20.8589C8.05693 20.7983 7.66872 20.714 7.28667 20.6064C5.18907 20.0145 3.34217 18.7538 2.02688 17.0159C0.711591 15.278 -0.00011743 13.158 1.45329e-08 10.9785C1.45329e-08 5.45644 4.47583 0.97852 10 0.97852H10.0046C11.365 0.977303 12.7113 1.25455 13.9606 1.7932C15.2099 2.33185 16.3357 3.1205 17.2688 4.1106C19.0236 5.96662 20.0009 8.42425 20 10.9785Z"
            fill="white"
        />
        <path
            d="M7.47654 8.00432V8.45432H6.02279L1.93945 5.0589C2.19185 4.71556 2.46603 4.38878 2.76029 4.08057L7.47654 8.00432Z"
            fill="#C8102E"
        />
        <path
            d="M18.0734 5.07724L14.0139 8.45224H12.5234V8.03474L17.2559 4.09766L17.2684 4.11057C17.5412 4.39813 17.7964 4.70188 18.0326 5.02016L18.0734 5.07724Z"
            fill="#C8102E"
        />
        <path
            d="M7.47612 13.502V13.952L2.75987 17.8765C2.7182 17.8349 2.67654 17.7899 2.63737 17.7461C2.38928 17.4766 2.15628 17.1935 1.93945 16.8982L6.02279 13.502H7.47612Z"
            fill="#C8102E"
        />
        <path
            d="M18.0739 16.8795C17.8225 17.223 17.5494 17.5502 17.2564 17.859L12.5234 13.9215V13.502H14.0139L18.0739 16.8795Z"
            fill="#C8102E"
        />
        <path
            d="M3.99379 8.45425H0.321289C0.529926 7.65414 0.837874 6.88329 1.23796 6.15967L3.99379 8.45425Z"
            fill="#012169"
        />
        <path
            d="M3.91087 13.502L1.20837 15.7495C0.822174 15.0392 0.524268 14.2845 0.321289 13.502H3.91087Z"
            fill="#012169"
        />
        <path
            d="M7.47589 15.6152V20.6569C7.41255 20.6407 7.35089 20.6236 7.2863 20.6057C5.97598 20.2367 4.75518 19.6031 3.69922 18.744L7.47589 15.6152Z"
            fill="#012169"
        />
        <path
            d="M7.47628 1.2998V6.26231L3.75586 3.1673C4.8507 2.28983 6.11849 1.65344 7.47628 1.2998Z"
            fill="#012169"
        />
        <path
            d="M16.3009 3.21404L12.5234 6.34529V1.30029L12.5805 1.31488C13.941 1.67779 15.209 2.32509 16.3009 3.21404Z"
            fill="#012169"
        />
        <path
            d="M19.679 8.45427H16.0957L18.792 6.21094C19.1778 6.91986 19.4757 7.6732 19.679 8.45427Z"
            fill="#012169"
        />
        <path
            d="M16.3329 18.7193C15.2187 19.6328 13.9197 20.294 12.5254 20.6572V15.5518L16.3329 18.7193Z"
            fill="#012169"
        />
        <path
            d="M19.6787 13.502C19.4801 14.2656 19.1912 15.0029 18.8183 15.6982L16.1787 13.502H19.6787Z"
            fill="#012169"
        />
        <path
            d="M20 10.8739V11.0735C19.9957 11.5398 19.9591 12.0052 19.8904 12.4664H11.4879V20.8685C11.0296 20.9369 10.5671 20.9736 10.1038 20.9785H9.89542C9.43189 20.9737 8.96926 20.9368 8.51083 20.8681V12.4664H0.11C0.041626 12.0076 0.00487275 11.5445 0 11.0806C0 11.0152 0 10.9493 0 10.8835C0.00431054 10.4171 0.040926 9.95154 0.109583 9.49018H8.51208V1.08852C8.9484 1.02328 9.38849 0.98654 9.82958 0.978516L10.1521 0.978516C10.573 0.984534 10.9932 1.0171 11.41 1.07602L11.4879 1.08768V9.49018H19.89C19.9584 9.94836 19.9951 10.4107 20 10.8739Z"
            fill="#C8102E"
        />
    </svg>
</template>